module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Sam Hawken\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('B', [_vm._v("Sam Hawken")]), _vm._v(" was born in Texas and currently lives outside Baltimore with his wife and son.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/nTNywb/images/9780316299251_cover_epub.jpg?1732976220275",
      "alt": "This image is the cover for the book Night Charter"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Night Charter\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Exactly one year ago, Camaro Espinoza killed five bad men in New York City and fled town. Now she's keeping a low profile in Miami, running night charter catch-and-release fishing trips off the coast. It's a simple life for a former combat medic. But it wasn't easy to come by. Camaro plans to do everything she can to hold onto it. "), _c('br'), _c('br'), _vm._v(" Trouble comes knocking in the form of Parker Story, a man in over his head with all the wrong people. Parker wants to book Camaro's boat to run a small errand off the coast of Cuba. Camaro knows she shouldn't get involved. But Parker's got a teenaged daughter named Lauren, and Parker's associates have threatened to harm her if the mission doesn't go off without a hitch. Camaro has never met the girl. Barely seen her picture. But that doesn't mean she can ignore her plight. "), _c('br'), _c('br'), _vm._v(" Camaro's used to being wanted -- by men good and bad, by soldiers wounded on the field of battle, by the long arm of the law. But she's never been needed before. Not the way Lauren needs her. Joining forces with Parker, Camaro soon finds herself in the midst of double crosses, international intrigue, broken promises and scattered bullets. Even a skilled warrior like herself may not be able to escape unscathed.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Little, Brown and Company\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0